import React from 'react';
import Navbar from '../components/Navbar';
import Hero from '../components/Hero';
import Marquee from '../components/Marquee';
import Stats from '../components/Stats';
import StaffingModel from '../components/StaffingModel';
import Services from '../components/Services';
import AIGovernance from '../components/AIGovernance';
import Work from '../components/Work';
import Studio from '../components/Studio';
import Contact from '../components/Contact';
import Footer from '../components/Footer';
import { Toaster } from '../components/ui/toaster';

export default function Home() {
  return (
    <div className="App">
      <Navbar />
      <main>
        <Hero />
        <Marquee />
        <Stats />
        <StaffingModel />
        <Services />
        <AIGovernance />
        <Work />
        <Studio />
        <Contact />
      </main>
      <Footer />
      <Toaster />
    </div>
  );
}
